import { useState } from 'react';
import contactTable from "../../assets/images/contact-detail.png";
import { useNavigate } from 'react-router';

export default function UserAgreement() {
  const [agreed, setAgreed] = useState(false);
  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAgreed(e.target.checked);
    if (e.target.checked) {
      setShowError(false);
    }
  };

  const handleSubmit = () => {
    if (!agreed) {
      setShowError(true);
      return;
    }
    // Handle submission logic here
    navigate("/under-review");
  };

  const termsContent = [
    {
      title: "1. Availing the Research Services",
      content: "By accepting the delivery of the research service, I confirm that I have voluntarily elected to subscribe to the research services of the Research Analyst (RA) at my sole discretion. I acknowledge that these services shall be rendered in accordance with the applicable provisions of the SEBI (Research Analyst) Regulations, 2014."
    },
    {
      title: "2. Obligations on RA",
      content: "The RA and I shall be bound by the SEBI Act and all applicable rules and regulations of SEBI, including the Research Analyst Regulations and relevant notifications issued from time to time."
    },
    {
      title: "3. Client Information and KYC",
      content: "I agree to furnish all required information and documents as mandated by SEBI/RAASB from time to time. I acknowledge that the RA shall collect, store, upload."
    },
    {
      title: "4. Standard Terms of Service",
      content: "I have read and understood the terms and conditions applicable to research analysts as defined under Regulation 2(1)(u) of the SEBI (Research Analyst) Regulations, 2014, including the fee structure. I am subscribing to the research services for my own benefit and consumption, and any reliance placed on the research report provided by the RA shall be based on my own judgment and assessment of the conclusions therein."
    },
    {
      title: "5. Investment Risks",
      content: "I understand that any investment made based on the recommendations in the research report is subject to market risks. Recommendations in the research report do not provide any assurance of returns. There is no recourse to claim any losses incurred based on such recommendations."
    },
    {
      title: "6. Research Analyst's Declaration",
      content: "The RA is duly registered with SEBI under the SEBI (Research Analyst) Regulations, 2014 (SEBI Registration No.: INH000014492, Registration Date: 12 Jan 2024). The RA possesses the required qualifications and complies with relevant legal provisions. The maximum fee charged by the RA is ₹1.51 lakhs per annum per family of clients."
    },
    {
      title: "",
      content: "The recommendations provided by RA do not provide any assurance of returns"
    },
    {
      title: "7. Risk Factors",
      content: "Investments in securities market are subject to market risks. Read all the related documents carefully before investing. Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investor. We do not provide any guaranteed profit or fixed returns or any other services. We charge fixed fees and do not operate on any profit-sharing model. Images if any, shared with you are for illustration purposes only. We are not responsible for any financial loss or any other loss incurred by the client. Please be fully informed about the risk and costs involved in trading and investing. Please consult your investment advisor before trading. Trade only as per your risk appetite and risk profile. Trading/investing in stock market is risky due to its volatile nature. Upon accepting our service, you hereby accept that you fully understand the risks involved in trading/investing. We advise the viewers to apply own discretion while referring testimonials shared by the client. Past performances and results are no guarantee of future performance. All Report or recommendations shared are confidential and for the reference of paid members only. Any unapproved distribution of sensitive data will be considered as a breach of confidentiality and appropriate legal action shall be initiated. The Research Report or recommendations must not be used as a singular basis of any investment decision. The views do not consider the risk appetite or the particular circumstances of an individual investor; readers are requested to take professional advice before investing and trading. Our recommendations should not be construed as investment advice. Reports based on technical and derivative analysis centre on studying charts of a stock's price movement, outstanding positions and trading volume, as opposed to focusing on a company's fundamentals and, as such, may not match with a report on a company's fundamentals."
    },
    {
      title: "8. Conflict of Interest",
      content: "a. Disclosure Document - The particulars given in this Disclosure Document have been prepared in accordance with SEBI (Research Analyst) Regulations, 2014.The purpose of the Document is to provide essential information about the Research and recommendation Services in a manner to assist and enable the perspective client/client in making an informed decision for engaging in Research and recommendation services before investing. For the purpose of this Disclosure Document, Research Analyst is Mr Krushnakant sudhirkumar rathi Individual Research analyst (here in after referred as “Research Analyst”). \n b. Descriptions about “Research Analyst” - Terms and conditions of Research and Recommendation Services are detailed in the terms and condition document. Please refer to the same for details. No penalties/directions have been issued by SEBI under the SEBI Act or Regulations made there under against the Research Analyst relating to Research Analyst services. There are no pending material litigations or legal proceedings, findings of inspections or investigations for which action has been taken or initiated by any regulatory authority against the Research Analyst or its employees. \n c. Details of its associates - No associates. \n d. Disclosures with respect to Research and Recommendations Services - Research Analyst may have financial interest or actual/beneficial ownership in the securities recommended in its personal portfolio. Details of the same may be referred through the disclosures made at the time of advice. \n There are no actual or potential conflicts of interest arising from any connection to or association with any issuer of products/securities, including any material information or facts that might compromise its objectivity or independence in the carrying on of Research Analyst services. Such conflict of interest shall be disclosed to the client as and when they arise. \n Research Analyst or its employee or its associates have not received any compensation from the subject company in past 12 months. \n Research Analyst or its employee or its associates have not managed or co-managed the public offering of Subject Company in past 12 months. \n Research Analyst or its employee or its associates have received any compensation for investment banking or merchant banking of brokerage services from the subject company in past 12 months. \n Research Analyst or its employee or its associates have not received any compensation for products or services other than above from the subject company in past 12 months. \n Research Analyst or its employee or its associates have not received any compensation or other benefits from the Subject Company or 3rd party in connection with the research report/recommendation. \n The subject company was not a client of Research Analyst or its employee or its associates during twelve months preceding the date of distribution of the research report and recommendation services provided. \n Research Analysts or its employee or its associates has not served as an officer, director or employee of the subject company. \n Research Analysts has not been engaged in market making activity of the subject company \n The RA agrees to comply with all applicable SEBI regulations, circulars, and directions concerning the disclosure and mitigation of any actual or potential conflicts of interest."
    },
    {
      title: "9. Termination of Service and Refund of Fees",
      content: "Disclosure \n RA may suspend or terminate rendering of research services to client on account of suspension/ cancellation of registration of RA by SEBI and shall refund the residual amount to the client. \n In case of suspension of certificate of registration of the RA for more than 60 (sixty) days or cancellation of the RA registration, RA shall refund the fees, on a pro rata basis for the period from the effective date of cancellation/ suspension to end of the subscription period"
    },
    {
      title: "10. Additional Clauses",
      content: "The RA reserves the right to introduce additional voluntary clauses that comply with SEBI’s rules, regulations, and circulars. Any changes to such clauses will be notified to the Client with a 15-day notice."
    },
    {
      title: "11. Mandatory Notice",
      content: "The Client acknowledges the receipt and understanding of the “Do’s and Don’ts” as specified in SEBI Master Circular SEBI/HO/MIRSD-POD1/P/CIR/2024/49 dated May 21, 2024 or as may be revised by SEBI from time to time."
    },
    {
      title: "12. Most Important Terms and Conditions (MITC)",
      content: "The RA will provide the Client with the Most Important Terms and Conditions (MITC) as standardized by the Industry Standards Forum (ISF) in consultation with SEBI and RAASB. \n a. These terms and conditions, and consent thereon are for the research services provided by the Research Analyst (RA) and RA cannot execute/carry out any trade (purchase/sell transaction) on behalf of, the client. Thus, the clients are advised not to permit RA to execute any trade on their behalf. \n b. The fee charged by RA to the client will be subject to the maximum of amount prescribed by SEBI/ Research Analyst Administration and Supervisory Body (RAASB) from time to time (applicable only for Individual and HUF Clients). \n Note- The current fee limit is Rs 1,51,000/- per annum per family of client for all research services of the RA. The fee limit does not include statutory charges. The fee limits do not apply to a non-individual client / accredited investor. \n c. RA may charge fees in advance if agreed by the client. Such advance	shall not exceed the period stipulated by SEBI; presently it is one quarter. In case of pre-mature termination of the RA services by either the client or the RA, the client shall be entitled to seek refund of proportionate fees only for unexpired period. \n d. Fees to RA may be paid by the client through any of the specified modes like cheque, online bank transfer, UPI, etc. Cash payment is not allowed. Optionally the client can make payments through Centralized Fee Collection Mechanism (CeFCoM) managed by BSE Limited (i.e. currently recognized RAASB). \n e. The RA is required to abide by the applicable regulations/ circulars/ directions specified by SEBI and RAASB from time to time in relation to disclosure and mitigation of any actual or potential conflict of interest. The RA will endeavour to promptly inform the client of any conflict of interest that may affect the services being rendered to the client. \n f. Any assured/guaranteed/fixed returns schemes or any other schemes of similar nature are prohibited by law. No scheme of this nature shall be offered to the client by the RA. \n g. The RA cannot guarantee returns, profits, accuracy, or risk-free investments from the use of the RA’s research services. All opinions, projections, estimates of the RA are based on the analysis of available data under certain assumptions as of the date of preparation/publication of research report. \n h. If any executive or sales representative provides assurances of guaranteed returns, engages in profit-sharing arrangements, or offers unauthorized services such as handling your demat account, please note that such actions are strictly prohibited by law. \n We strongly advise clients not to act on such advice under any circumstances. Should you come across any such conduct, please report it immediately to us at via email at rathiequity6031@gmail.com	so that appropriate disciplinary measures can be taken against the responsible individual. \n If a client acts on any unauthorized recommendations during or after the expiry of their subscription, Krushnakant Sudhirkumar Rathi Proprietor of Rathi Equity Research shall not be held responsible for any resulting losses, and no refunds shall be issued for services whose validity has lapsed. \n Furthermore, we strongly recommend that all clients implement a stop-loss while trading to manage risk appropriately. Please be advised that does not bear responsibility for any profits or losses arising from your individual trading or investment decisions. \n i. Any investment made based on recommendations in research reports are subject to market risks, and recommendations do not provide any assurance of returns. There is no recourse to claim any losses incurred on the investments made based on the recommendations in the research report. Any reliance placed on the research report provided by the RA shall be as per the client’s own judgement and assessment of the conclusions contained in the research report. \n j. The SEBI registration, Enlistment with RAASB, and NISM certification do not guarantee the performance of the RA or assure any returns to the client. \n k. For any grievances, \n Step 1: the client should first contact the RA using the details on its website or following contact details (at bottom) \n Step 2: If the resolution is unsatisfactory, the client can also lodge grievances through SEBI’s SCORES platform at www.scores.sebi.gov.in \nStep 3: The client may also consider the Online Dispute Resolution (ODR) through the Smart ODR portal at https://smartodr.in \n l. Clients are required to keep contact details, including email id and mobile number/s updated with the RA at all times. \n m. The RA shall never ask for the client’s login credentials and OTPs for the client’s Trading Account Demat Account and Bank Account. Never share such information with anyone including RA."
    },
  ];

  return (
    <div style={{
      minHeight: '100vh',
      maxWidth: '500px',
      backgroundColor: 'var(--background-color)',
      color: 'var(--text-color-5)',
      display: 'flex',
      marginLeft: 'auto',
      marginRight: 'auto',
      flexDirection: 'column',
      fontFamily: 'Inter, sans-serif'
    }}>
      {/* Header - Fixed */}
      <div style={{
        padding: '1rem 1rem 1.25rem',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        backgroundColor: 'var(--background-color)',
        position: 'sticky',
        top: 0,
        zIndex: 10
      }}>
        <h1 style={{
          color: 'var(--text-color-1)',
          fontSize: '1.5rem',
          fontWeight: '700',
          margin: '0 0 0.25rem 0',
          fontFamily: 'Denton Test, sans-serif'
        }}>
          Terms & Conditions
        </h1>
        <p style={{
          color: 'var(--text-color-2)',
          fontSize: '0.875rem',
          margin: '0',
          fontFamily: 'Denton Test, sans-serif'
        }}>
          Most Important Terms and Conditions (MITC)
        </p>
      </div>

      {/* Scrollable Terms Content */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '1rem',
        WebkitOverflowScrolling: 'touch'
      }}>
        <style>
          {`
            div::-webkit-scrollbar {
              width: 6px;
            }
            div::-webkit-scrollbar-track {
              background: transparent;
            }
            div::-webkit-scrollbar-thumb {
              background: var(--primary-color);
              border-radius: 10px;
            }
          `}
        </style>
        
        {/* Research Analyst Details */}
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.03)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '8px',
          padding: '1rem',
          marginBottom: '3rem',
          textAlign: 'left'
        }}>
          <h3 style={{
            color: 'var(--text-color-1)',
            fontSize: '0.9375rem',
            fontWeight: '600',
            marginBottom: '0.75rem',
            marginTop: '0',
            fontFamily: 'Inter, sans-serif'
          }}>
            Research Analyst Details
          </h3>
          <div style={{ fontSize: '0.8125rem', color: 'var(--text-color-2)', lineHeight: '1.6' }}>
            <p style={{ margin: '0 0 0.375rem 0' }}><strong style={{ color: 'var(--text-color-4)' }}>Name:</strong> Krushnakant Sudhirkumar Rathi (Proprietor of Rathi Equity Research)</p>
            <p style={{ margin: '0 0 0.375rem 0' }}><strong style={{ color: 'var(--text-color-4)' }}>SEBI Registration No.:</strong> INH000014492</p>
            <p style={{ margin: '0' }}><strong style={{ color: 'var(--text-color-4)' }}>Address:</strong> 317, Third Floor, Galleria Tower, DLF City Phase 4, Gurugram - 122009</p>
          </div>
        </div>

        {termsContent.map((section, index) => (
          <div key={index} style={{
            marginBottom: '1.5rem',
            paddingBottom: '1.5rem',
            borderBottom: index < termsContent.length - 1 ? '1px solid rgba(255, 255, 255, 0.05)' : 'none',
            textAlign: 'left'
          }}>
            <h3 style={{
              color: 'var(--text-color-1)',
              fontSize: '0.9375rem',
              fontWeight: '600',
              marginBottom: '0.5rem',
              fontFamily: 'Inter, sans-serif'
            }}>
              {section.title}
            </h3>
            <p style={{
              color: 'var(--text-color-2)',
              fontSize: '0.8125rem',
              lineHeight: '1.6',
              margin: '0',
              whiteSpace: 'pre-line'
            }}>
              {section.content}
            </p>
          </div>
        ))}

        <div style={{
          textAlign: 'center',
          marginTop: '1rem',
          paddingBottom: '1rem'
        }}>
          <p style={{
            color: 'var(--text-color-6)',
            fontSize: '0.75rem',
            lineHeight: '1.5',
            margin: '0'
          }}>
            Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.
          </p>
        </div>
      </div>

      <div style={{padding: '0 10px'}}><img src={contactTable} alt="" style={{width: '100%'}} /></div>

      {/* Fixed Bottom Section - Checkbox + Buttons */}
      <div style={{
        backgroundColor: 'var(--background-color)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '1rem',
        boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Agreement Checkbox */}
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.03)',
          border: `1.5px solid ${showError ? 'var(--primary-color)' : 'rgba(255, 255, 255, 0.15)'}`,
          borderRadius: '10px',
          padding: '1rem',
          marginBottom: '1rem',
          transition: 'all 0.3s ease',
          textAlign: 'left'
        }}>
          <label style={{
            display: 'flex',
            alignItems: 'flex-start',
            cursor: 'pointer',
            gap: '0.75rem',
            WebkitTapHighlightColor: 'transparent'
          }}>
            <input
              type="checkbox"
              checked={agreed}
              onChange={handleCheckboxChange}
              style={{
                width: '20px',
                height: '20px',
                minWidth: '20px',
                accentColor: 'var(--primary-color)',
                cursor: 'pointer',
                marginTop: '1px'
              }}
            />
            <span style={{
              color: 'var(--text-color-1)',
              fontSize: '0.9375rem',
              lineHeight: '1.5',
              userSelect: 'none'
            }}>
              I have read, understood, and agree to abide by the Most Important Terms and Conditions (MITC) for availing the services of Rathi Equity Research. I acknowledge that I am fully aware of the risks and responsibilities associated with trading and investing based on research services.
            </span>
          </label>
          
          {showError && (
            <div style={{
              color: 'var(--primary-color)',
              fontSize: '0.8125rem',
              marginTop: '0.625rem',
              marginLeft: '1.75rem',
              animation: 'shake 0.3s ease-in-out'
            }}>
              <style>
                {`
                  @keyframes shake {
                    0%, 100% { transform: translateX(0); }
                    25% { transform: translateX(-5px); }
                    75% { transform: translateX(5px); }
                  }
                `}
              </style>
              Please accept the terms to continue
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          flexDirection: 'column-reverse',
          gap: '0.75rem'
        }}>
          
          <button
            onClick={handleSubmit}
            disabled={!agreed}
            style={{
              width: '100%',
              padding: '1rem',
              background: agreed ? 'var(--primary-color)' : 'rgba(255, 255, 255, 0.1)',
              color: agreed ? 'var(--text-color-1)' : 'var(--text-color-3)',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: agreed ? 'pointer' : 'not-allowed',
              transition: 'all 0.2s ease',
              opacity: agreed ? '1' : '0.5',
              fontFamily: 'Inter, sans-serif',
              boxShadow: agreed ? 'var(--box-shadow-1)' : 'none',
              WebkitTapHighlightColor: 'transparent',
              touchAction: 'manipulation'
            }}
          >
            Accept & Continue
          </button>
        </div>
      </div>

      {/* Desktop Styles - Progressive Enhancement */}
      <style>
        {`
          @media (min-width: 768px) {
            .user-agreement-container {
              max-width: 900px;
              margin: 0 auto;
              padding: 2rem 1.5rem;
            }
          }
        `}
      </style>
    </div>
  );
}